// Base URL for development server
export const BASE_URL = "https://api.spouze.co"
// export const BASE_URL = "http://localhost:3000"
export const APP_NAME="Spouze"